<template>
  <div class="toggle-bookmark-wrapper">
    <span>
      <font-awesome-icon
        class="fa-trash"
        :icon="['fas', 'trash']"
        v-if="!bookmarkRowValue.showUndo"
        @click="removeBookmark"
      />
    </span>
    <div v-if="bookmarkRowValue.showUndo" class="undo-popup">
      <div class="undo-popup-card px-2 py-1">
        Bookmark removed. <a class="undo-link" @click="saveBookmark">Undo</a>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import * as CONSTANTS from "@/store/constants";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

library.add(faTrash);

export default {
  name: "AutodeskOneToggleBookmarkPage",
  data() {
    return {
      bookmark: {},
    };
  },
  props: {
    bookmarkRowValue: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async saveBookmark() {
      api
        .saveBookmark(
          this.bookmarkRowValue.title,
          this.bookmarkRowValue.url,
          this.bookmarkRowValue.sourceType,
          this.bookmarkRowValue.id,
          this.bookmarkRowValue.isPin
        )
        .then((response) => {
          const { data: bookmark } = response;
          this.bookmarkRowValue.id = response.data.id;
          this.bookmark = { ...bookmark };
          this.$emit("bookmarkRemovalUndo")
          this.trackEvent("Bookmark saved", this.bookmarkRowValue.title);
        })
        .catch((err) => {
          this.updateMessage("Error", CONSTANTS.ERROR_MESSAGE);
        });
    },

    async removeBookmark() {
      api
        .removeBookmark(
          this.bookmarkRowValue.id,
          this.bookmarkRowValue.sourceType
        )
        .then(() => {
          this.trackEvent("Bookmark removed", this.bookmarkRowValue.title);
          this.$emit("bookmarkRemoved")
        })
        .catch((err) => {
          // this.updateMessage("Error", CONSTANTS.ERROR_MESSAGE);
        });
    },
  },
};
</script>
<style scoped>
.bookmark-icon {
  color: var(--bookmark-color) !important;
  cursor: pointer;
}
.toggle-bookmark-wrapper {
  position: relative;
}
.undo-popup {
  color: #666;
  font-family: artifaktElementBold !important;
  position: absolute;
  right: calc(100% + 12px);
  top: -20px;
  z-index: 14 !important;
}
.undo-popup-card {
  background: white;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 4px;
}
.undo-link {
  font-family: artifaktElementBold !important;
  cursor: pointer;
}

.fa-trash {
  color: #ccc !important;
}
.fa-trash:hover {
  color: #666 !important;
  cursor: pointer;
}
</style>